// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextFormattingInput__container-f320f7 {
  display: flex;
  width: 100%;
}

.TextFormattingInput__input-container-e5d020 {
  position: relative;
  display: flex;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.TextFormattingInput__input-a4bece {
  flex: 1;
  max-height: 300px;
  padding: 14px 12px 12px 12px;
  box-sizing: border-box;
  color: var(--base-110);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  border-bottom: 2px solid transparent;
  background-color: var(--base-20);
  cursor: text;
  scrollbar-color: var(--base-20);
}

.TextFormattingInput__input-a4bece:focus {
  border-color: var(--brand-secondary-40);
}

.TextFormattingInput__input-a4bece::-webkit-scrollbar-track {
  background-color: var(--base-20);
}

.TextFormattingInput__containputiner-ae8dba::-webkit-scrollbar {
  background-color: var(--base-20);
}

@supports (scrollbar-width: auto) {
  .TextFormattingInput__input-a4bece {
    scrollbar-color: var(--base-50) var(--base-20);
  }
}
.TextFormattingInput__placeholder-d1ae75 {
  position: absolute;
  inset-inline-start: 0px;
  top: 0px;
  width: 100%;
  padding: 14px 12px;
  box-sizing: border-box;
  color: var(--base-70);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/TextFormattingInput/TextFormattingInput.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,OAAA;EACA,iBAAA;EACA,4BAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,oCAAA;EACA,gCAAA;EACA,YAAA;EACA,+BAAA;AACF;;AAEA;EACE,uCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE;IACE,8CAAA;EACF;AACF;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,oBAAA;AAAF","sourcesContent":[".container {\n  display: flex;\n  width: 100%;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  width: 100%;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.input {\n  flex: 1;\n  max-height: 300px;\n  padding: 14px 12px 12px 12px;\n  box-sizing: border-box;\n  color: var(--base-110);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  overflow-y: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n  border-bottom: 2px solid transparent;\n  background-color: var(--base-20);\n  cursor: text;\n  scrollbar-color: var(--base-20);\n}\n\n.input:focus {\n  border-color: var(--brand-secondary-40);\n}\n\n.input::-webkit-scrollbar-track {\n  background-color: var(--base-20);\n}\n\n.containputiner::-webkit-scrollbar {\n  background-color: var(--base-20);\n}\n\n@supports (scrollbar-width: auto) {\n  .input {\n    scrollbar-color: var(--base-50) var(--base-20);\n  }\n}\n\n.placeholder {\n  position: absolute;\n  inset-inline-start: 0px;\n  top: 0px;\n  width: 100%;\n  padding: 14px 12px;\n  box-sizing: border-box;\n  color: var(--base-70);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TextFormattingInput__container-f320f7`,
	"input-container": `TextFormattingInput__input-container-e5d020`,
	"inputContainer": `TextFormattingInput__input-container-e5d020`,
	"input": `TextFormattingInput__input-a4bece`,
	"containputiner": `TextFormattingInput__containputiner-ae8dba`,
	"placeholder": `TextFormattingInput__placeholder-d1ae75`
};
module.exports = ___CSS_LOADER_EXPORT___;
